
import React, { useRef, useEffect, useState } from 'react';
import ContactForm from './contact/ContactForm';
import ContactInfo from './contact/ContactInfo';

const Contact: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section id="contact" className="py-20 bg-white section-padding" ref={sectionRef}>
      <div className="container-width">
        <div className="text-center mb-16">
          <span className={`inline-block px-3 py-1 bg-blue-50 text-presintention-accent rounded-full text-sm font-medium mb-4 transition-all duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
            Contact Us
          </span>
          <h2 className={`text-3xl md:text-4xl font-bold mb-6 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-4'}`}>
            Ready to <span className="text-gradient">Transform</span> Your Presentations?
          </h2>
          <p className={`max-w-2xl mx-auto text-presintention-muted text-lg transition-all duration-700 delay-200 ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-4'}`}>
            Schedule a consultation or reach out with any questions. We're here to help you become a more confident, compelling presenter.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <ContactInfo isVisible={isVisible} />
          <ContactForm isVisible={isVisible} />
        </div>
      </div>
    </section>
  );
};

export default Contact;
